import { Injectable } from '@angular/core';

const STORAGE_KEY = 'epago-console-recent';
const MAX = 4;

export interface RecentNavItem {
  path: string;
  label: string;
}

@Injectable({ providedIn: 'root' })
export class NavigationHistoryService {
  private readonly labels: Record<string, string> = {
    '/checkout2': 'Checkout',
    '/checkout-react-qr': 'Checkout React QR',
    '/paylink': 'PayLink',
    '/sip-pay': 'Pago con Sip',
    '/card-register': 'Registro de tarjeta',
    '/saved-card-pay': 'Pago tokenizado',
    '/processor-benefit': 'Procesador Benefit',
    '/agora-simulator-control': 'Control del simulador',
    '/izipay-generator': 'Generador por lote F5',
    '/estilos-inyectables': 'Estilos inyectables',
    '/ordenes': 'Órdenes',
    '/vtex': 'VTEX',
    '/demo1': 'Demo FA',
    '/izipay-excel-generator': 'Izipay Excel',
  };

  record(path: string): void {
    const label = this.labels[path];
    if (!label) {
      return;
    }
    let items = this.getRecent();
    items = items.filter((i) => i.path !== path);
    items.unshift({ path, label });
    items = items.slice(0, MAX);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch {
      /* ignore */
    }
  }

  getRecent(): RecentNavItem[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        return [];
      }
      const parsed = JSON.parse(raw) as RecentNavItem[];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
}
